// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"8f911b5c","219":"336d4dac","307":"1eebdef7","314":"a92bb21f","478":"0b10cb04","530":"8569fd85","596":"838bb049","681":"f2490f7d","759":"5896cd9c","799":"fe92088a","828":"c50967a3","845":"25c6d837","855":"29b7763f"}[chunkId] + ".chunk.js";
};